import type { SVGProps } from 'react';

interface RemoteDeviceSvgProps extends Omit<SVGProps<SVGSVGElement>, 'fill'> {
  size?: number;
}

/**
 * Inline SVG of the Heidi Remote device icon.
 *
 * Drawn on a 24x24 grid to match the lucide-react icon set. Uses `currentColor`
 * for stroke/fill so the icon inherits the parent's text color in both light and
 * dark themes. Set the color by applying a `text-*` utility on the icon or any
 * ancestor.
 */
export const RemoteDeviceSvg = ({
  size,
  className,
  width,
  height,
  ...props
}: RemoteDeviceSvgProps) => {
  return (
    <svg
      width={size ?? width ?? 24}
      height={size ?? height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
      {...props}
    >
      <path d="M15.3986 8.60136L13.9394 10.0606M20.4085 3.59149C19.6197 2.80269 18.3414 2.80298 17.5524 3.59149C17.3945 3.74933 17.1606 3.82199 16.9495 3.74941C15.0851 3.10847 12.9359 3.53186 11.4479 5.01955L4.56005 11.9074C2.47999 13.9874 2.47998 17.3599 4.56005 19.44C6.64011 21.52 10.0126 21.52 12.0926 19.44L18.9804 12.5521C20.4678 11.0644 20.8918 8.91566 20.2516 7.05158C20.1791 6.84052 20.2507 6.60541 20.4085 6.44762C21.197 5.65864 21.1973 4.38028 20.4085 3.59149Z" />
      <path
        d="M7.76727 14.5817C7.31139 15.0376 7.31139 15.7767 7.76727 16.2326C8.22316 16.6885 8.96231 16.6885 9.4182 16.2326C9.87409 15.7767 9.87409 15.0376 9.4182 14.5817C8.96231 14.1258 8.22316 14.1258 7.76727 14.5817Z"
        fill="currentColor"
      />
    </svg>
  );
};
